import React from 'react';
import PropTypes from 'prop-types';

export default function AutoPlayVideo({ src, autoplay, location, ...attributes }) {
  if (!src) return false;
  const video = `https://www.youtube.com/embed/${src}?enablejsapi=1&version=3&playerapiid=ytplayer&autoplay=${autoplay ? 1 : 0}&showinfo=0&rel=0&loop=1&onPlayerReady&origin=${window.location.origin}`;

  return (
    <iframe
      allowFullScreen
      scrolling="no"
      frameBorder="0"
      src={video}
      loading="lazy"
      allow="autoplay"
      {...attributes}
    />
  );
}

AutoPlayVideo.propTypes = {
  src: PropTypes.string.isRequired,
  autoplay: PropTypes.bool,
};

AutoPlayVideo.defaultProps = {
  autoplay: true,
};
